import React, { FC, Fragment } from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { useStyles } from "../../useStyles";
import { ChangeNames, ChangeTypes } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";
import { InfoBoxRemovalPowerSubject } from "../core/InfoBox";
import { useCurrentConfiguration } from "../../utils/hooks";

const convertValue = (value: ChangeTypes[ChangeNames.REMOVAL_RECONSTRUCTION]["value"]): string => {
    if (value.yes) {
        return "yes";
    } else if (value.no) {
        return "no";
    }
    return "";
};

export const RemovalReconstructionForm: FC = () => {
    const { values, setValues, submitChange } = useFormModel<ChangeNames.REMOVAL_RECONSTRUCTION>();
    const classes = useStyles();
    const selection = convertValue(values.removalReconstruction.value);
    const configuration = useCurrentConfiguration();

    return (
        <Fragment>
            {configuration.state.productClasses?.state.value.gas ? (
                <InfoBoxRemovalPowerSubject />
            ) : (
                <Fragment />
            )}
            <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 50 }}>
                Erfolgt eine Wiederbebauung des Grundstücks?
            </h4>
            <FormControl
                component="fieldset"
                className={classes.container}
                style={{ display: "flex" }}
            >
                <RadioGroup
                    value={selection}
                    onChange={(e, v) => {
                        const newValues = setValues(values => {
                            values.removalReconstruction.value.yes = v.indexOf("yes") >= 0;
                            values.removalReconstruction.value.no = v.indexOf("no") >= 0;
                        });
                        submitChange(newValues);
                    }}
                >
                    <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Ja"
                        error={values.removalReconstruction.error !== null}
                    />
                    <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="Nein"
                        sublabel="Es ist nicht geplant, das Grundstück wieder zu bebauen. Wir kündigen das Netzanschlussverhältnis mit sofortiger Wirkung und bitten um Demontage des Netzanschlusses."
                        error={values.removalReconstruction.error !== null}
                    />
                </RadioGroup>
            </FormControl>
        </Fragment>
    );
};
